import { render, staticRenderFns } from "./ProductPageScreenProduct.vue?vue&type=template&id=66e8ebbf&scoped=true&"
import script from "./ProductPageScreenProduct.vue?vue&type=script&lang=js&"
export * from "./ProductPageScreenProduct.vue?vue&type=script&lang=js&"
import style0 from "./ProductPageScreenProduct.vue?vue&type=style&index=0&id=66e8ebbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e8ebbf",
  null
  
)

export default component.exports